import React from 'react';
import QRCodeGenerator from './QRCodeGenerator';

function App() {
    return (
        <div className="App">
            <QRCodeGenerator />
        </div>
    );
}

export default App;
